export default {
  empty: {
    title: '暂无数据',
    description: '暂无相关数据'
  },
  search: {
    title: '查询无结果',
    description: '可尝试修改查询条件'
  }
};
